enum Event {
  RELOAD = 'deepsquare.reload',
}

export default Event;
